










































































import Vue from 'vue';
import { mapGetters } from 'vuex';
import EssayView from '@/components/EssayView.vue';
import CorrectionSidebar from '@/components/correction/CorrectionSidebar.vue';
import CorrectionSummary from '@/components/correction/CorrectionSummary.vue';
import CorrectionScores from '@/components/correction/CorrectionScores.vue';
import AnnotationCarousel from '@/components/correction/AnnotationCarousel.vue';
import SkillDescription from '@/components/correction/SkillDescription.vue';

export default Vue.extend({
  components: {
    EssayView,
    CorrectionSidebar,
    CorrectionSummary,
    CorrectionScores,
    AnnotationCarousel,
    SkillDescription,
  },
  computed: {
    ...mapGetters({
      essayByPosition: 'essayByPosition',
      skillDescriptionActive: 'skillDescriptionActive',
    }),
    essay() {
      return this.essayByPosition(
        this.$route.params.subjectSlug,
        +this.$route.params.position - 1,
      );
    },
    subject() {
      return this.essay.subject && this.essay.subject();
    },
    correction() {
      return this.essay.correction && this.essay.correction();
    },
  },
  created() {
    if (this.$route.name != 'correction') {
      this.$router.push(`${this.$route.path}/correcao`);
    }
    this.$store.dispatch('PULL_CORRECTION', {
      slug: this.$route.params.subjectSlug,
      position: this.$route.params.position - 1,
    });
  },
});
